import * as Yup from 'yup';

const schema = Yup.object().shape({
  acronym: Yup.string().required(' ').max(5, ' '),

  name: Yup.string().required(' '),
});

export default schema;
